<template>
  <span v-tooltip.top-center="text.length > length ? text : ``">
    {{ text.substring(0, length) }}{{ text.length > length ? `...` : `` }}
  </span>
</template>
<script>
export default {
  name: 'abbreviated-text-tooltip',
  props: {
    text: {
      type: String,
      default: '',
    },
    length: {
      type: Number,
      default: 25,
    },
  },
};
</script>
